import React from "react";
import PropTypes from "prop-types";
import { Card, Collapse, Tag, List as AntList, Icon, Button } from "antd";
import { DocumentsService } from "services/index";

import "./../../styles/documents-compliance.css";
const ListItem = AntList.Item;

const Panel = Collapse.Panel;

class DocumentCompliance extends React.Component {
    getExtra(requiredDocuments) {
        const requireDocumentsTypes = requiredDocuments.map(_ => _.id);
        const uploadedDocumentsSize = this.props.documents.get("data")
            ? this.props.documents
                .get("data")
                .map(_ => _.get("data"))
                .groupBy(_ => _.document)
                .filter((v, k) => requireDocumentsTypes.includes(k))
                .map(_ => _.size)
                .reduce((agg, val) => +agg + +val, 0)
            : 0;

        return (
            <Tag color={"#246079"}>
                {/* {`${uploadedDocumentsSize} / ${requiredDocumentsSize}`} */}
                {uploadedDocumentsSize}
            </Tag>
        );
    }
    getPanelContent(requiredDocuments) {
        const { showDocuments } = this.props;
        if (this.props.documents.get("data")) {
            const groupedDocuments = this.props.documents
                .get("data")
                .groupBy(_ => _.get("data").document);

            return (
                <AntList className={"documents-compliance"}>
                    {requiredDocuments.map(_ => {
                        if(!groupedDocuments.get(_.id)) {
                            return null;
                        }
                        return groupedDocuments.get(_.id) && groupedDocuments.get(_.id)
                            .map(__ => __.get("data"))
                            .map((__) => ( <ListItem key={__.id}>
                                    <ListItem.Meta title={__.file && __.file.file_name} />
                                    <React.Fragment>
                                        <Button
                                            type="link"
                                            onClick={showDocuments.bind(
                                                null,
                                                null,
                                                __.file && __.file.file,
                                                __.file && __.file.file_name
                                            )}>
                                            View
                                        </Button>
                                        <Icon
                                            style={{
                                                color: "#87d068",
                                                fontSize: "18px"
                                            }}
                                            type={"check-circle"}
                                            theme={"filled"}
                                        />
                                    </React.Fragment>
                                </ListItem> 
                        )).toList().toArray();
                    }                  
                    )}
                </AntList>
            );
        }
        return null;
    }

    downloadFiles = () => {
        DocumentsService.downloadDocuments(this.props.caseId).then(_ => {
            let file = new File(_.data, "documents_" + this.props.caseId);
            console.log(file);
        }).catch(() => {});
    };

    render() {
        return (
            <Card
                className={"padless-card no-border-transparent border-none-header"}
                // title={"Document Compliance"}
                extra={<a href={`${process.env.BASE_URL}/company/document/${this.props.caseId}/zip-download/`} download>Download</a>}>
                <div className={"p-5"}>
                    <Collapse style={{background: "#fff"}} bordered={true} expandIconPosition={"right"}>
                        {this.props.checklist.get("data") &&
                            this.props.checklist.get("data").map(_ => {
                                return _.documents && _.documents.length && (this.props.documents && this.props.documents.get("data")
                                    ? this.props.documents
                                        .get("data")
                                        .map(__ => __.get("data"))
                                        .groupBy(__ => __.document)
                                        .filter((v, k) => _.documents.map(_ => _.id).includes(k)).size : 0) ? (
                                        <Panel
                                            header={_.name}
                                            key={_.name}
                                            extra={this.getExtra(_.documents)}>
                                            {this.getPanelContent(_.documents)}
                                        </Panel>
                                    ) : null;
                            })}
                    </Collapse>
                </div>
            </Card>
        );
    }
}

DocumentCompliance.propTypes = {
    checklist: PropTypes.object,
    documents: PropTypes.object,
    showDocuments: PropTypes.func,
    caseId: PropTypes.string,
    companyName: PropTypes.string
};

export default DocumentCompliance;
